/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'notifications': {
    width: 18,
    height: 20,
    viewBox: '0 0 18 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.485 3.354a.547.547 0 01-.24.208A6.45 6.45 0 003.57 9.073v2.987a.549.549 0 01-.004.066A4.55 4.55 0 012.53 14.51h12.98a4.55 4.55 0 01-1.036-2.384.54.54 0 01-.004-.066V9.073a6.45 6.45 0 00-3.685-5.516.55.55 0 01-.315-.497 1.45 1.45 0 00-2.9-.01.552.552 0 01-.085.304zM2.47 9.034a7.55 7.55 0 014.023-6.326 2.55 2.55 0 015.052 0A7.55 7.55 0 0115.57 9.06v2.966a3.45 3.45 0 001.721 2.555.55.55 0 01-.271 1.029h-4.45v.45a3.55 3.55 0 01-7.1 0v-.45H1.02a.55.55 0 01-.271-1.029 3.45 3.45 0 001.721-2.555V9.06v-.026zm4.1 6.576v.45a2.45 2.45 0 104.9 0v-.45h-4.9z" _fill="#1D3861"/>'
  }
})
